import { createFileRoute } from "@tanstack/react-router";
import { LegalPage } from "@/components/legal-page";

export const Route = createFileRoute("/terms")({
  head: () => ({
    meta: [
      { title: "Terms of Service — Pyng" },
      { name: "description", content: "The terms that apply when you use Pyng." },
      { property: "og:title", content: "Terms of Service — Pyng" },
      { property: "og:description", content: "The terms that apply when you use Pyng." },
    ],
  }),
  component: TermsPage,
});

function TermsPage() {
  return (
    <LegalPage title="Terms of Service" lastUpdated="May 2026">
      <p>By creating a Pyng account or using the app, you agree to these terms. We've kept them short and human.</p>

      <h2>Your account</h2>
      <p>You're responsible for keeping your login secure. You must be at least 16 years old to use Pyng. One person, one account.</p>

      <h2>Your data, your rules</h2>
      <p>You own the contacts, memories, and notes you put into Pyng. We only access them to provide the service. You can export or delete everything at any time.</p>

      <h2>Acceptable use</h2>
      <ul>
        <li>Don't use Pyng to harass, deceive, or stalk anyone.</li>
        <li>Don't upload data you don't have the right to store.</li>
        <li>Don't try to break, reverse-engineer, or abuse the service.</li>
      </ul>

      <h2>AI-generated drafts</h2>
      <p>Pyng suggests drafts and summaries to help you reach out. Nothing is sent on your behalf without your tap. You're responsible for reviewing what you send.</p>

      <h2>Service availability</h2>
      <p>We work hard to keep Pyng running but can't guarantee uninterrupted service. We may update features as the product evolves.</p>

      <h2>No guarantee of coverage</h2>
      <p>
        Pyng surfaces publicly available signals on a best-efforts basis. It is not a market-data feed,
        a compliance tool, or a source of financial, legal, or investment advice, and it does not
        guarantee that any particular event will be detected, detected in time, or detected at all.
        Coverage depends on what sources publish and when. You remain responsible for your own research
        and outreach decisions, and a signal that Pyng did not flag is not a basis for liability.
      </p>

      <h2>Trials, billing and refunds</h2>
      <p>
        New accounts start on a 14-day Pro trial with no card required; at the end of the trial you drop
        to Free rather than losing access. Paid plans are billed monthly and you can cancel anytime from
        settings, which stops the next charge. If you're unhappy within 14 days of a charge, email
        <a href="mailto:support@pyng.co"> support@pyng.co</a> and we'll refund it.
      </p>

      <h2>Termination</h2>
      <p>You can close your account anytime from settings. We may suspend accounts that violate these terms.</p>

      <h2>Liability</h2>
      <p>Pyng is provided "as is." To the extent allowed by law, we're not liable for indirect or consequential damages arising from your use of the service.</p>

      <h2>Changes</h2>
      <p>If we change these terms in a material way, we'll let you know via email and in-app.</p>
    </LegalPage>
  );
}
